import { Component } from '@angular/core';
import { SkyModalController } from './modal-controller';

@Component({
  selector: 'sky-modal-default',
  template: `
    <header class="flex flex-col text-center">
      <a class="ml-auto cursor-pointer" (click)="close()"><sky-svg-icon size="w-6" icon="close"></sky-svg-icon></a>
      <h2 class="text-xl font-semibold pr-10 mt-2">{{ model.defaultTitle }}</h2>
    </header>
    <main class="my-8 text-center">
      {{ model.defaultContent }}
    </main>
    <footer class="flex justify-center">
      <button class="sky-btn-sky-blue" (click)="confirm()">{{ model.defaultDismissButtonLabel }}</button>
    </footer>
  `,
})
export class SkyModalDefaultComponent extends SkyModalController {}
